module.exports = __webpack_public_path__ + "img/bg21.fbc8ec1a.png";